var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _path8, _rect5, _rect6, _rect7, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMcfHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 22.5,
    width: 27,
    height: 1.125,
    rx: 0.5625,
    fill: "#CDE9E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 15.75C1.99816 15.75 2.25 16.0018 2.25 16.3125L2.25 21.375L1.125 21.375L1.125 16.3125C1.125 16.0018 1.37684 15.75 1.6875 15.75Z",
    fill: "#CDE9E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 16.875C6.86764 16.875 7.875 17.8824 7.875 19.125L7.875 21.375L3.375 21.375L3.375 19.125C3.375 17.8824 4.38236 16.875 5.625 16.875Z",
    fill: "#CDE9E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 16.875C14.9945 16.875 15.75 17.6305 15.75 18.5625L15.75 21.375L12.375 21.375L12.375 18.5625C12.375 17.6305 13.1305 16.875 14.0625 16.875Z",
    fill: "#CDE9E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 20.182L27 21.7702L21.1765 21.7702L21.1765 20.182C21.7482 20.5635 22.1718 20.5635 22.553 20.182C22.6528 20.0523 22.7504 19.9464 22.8457 19.8644L23.7497 19.8644C23.8295 19.9464 23.9071 20.0523 23.9824 20.182C24.5541 20.8879 25.0306 20.8879 25.4118 20.182C25.7131 19.772 26.3483 19.772 27 20.182Z",
    fill: "#CDE9E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7497 19.8644L22.8457 19.8644C23.1738 19.582 23.4751 19.582 23.7497 19.8644Z",
    fill: "#CDE9E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.7702L27 20.182C26.3483 19.772 25.7131 19.772 25.4118 20.182C25.0306 20.8879 24.5541 20.8879 23.9824 20.182C23.9071 20.0523 23.8295 19.9464 23.7497 19.8644L22.8457 19.8644C22.7504 19.9464 22.6528 20.0523 22.553 20.182C22.1718 20.5635 21.7482 20.5635 21.1765 20.182L21.1765 21.7702L27 21.7702Z",
    fill: "#CDE9E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.7702L27 20.182C26.3483 19.772 25.7131 19.772 25.4118 20.182C25.0306 20.8879 24.5541 20.8879 23.9824 20.182C23.9071 20.0523 23.8295 19.9464 23.7497 19.8644L22.8457 19.8644C22.7504 19.9464 22.6528 20.0523 22.553 20.182C22.1718 20.5635 21.7482 20.5635 21.1765 20.182L21.1765 21.7702L27 21.7702Z",
    fill: "#CDE9E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 13.5,
    width: 3.375,
    height: 3.375,
    rx: 1.6875,
    transform: "rotate(90 15.75 13.5)",
    fill: "#CDE9E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.25,
    y: 13.5,
    width: 3.375,
    height: 3.375,
    rx: 1.6875,
    transform: "rotate(90 20.25 13.5)",
    fill: "#CDE9E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.25,
    y: 18,
    width: 3.375,
    height: 3.375,
    rx: 1.6875,
    transform: "rotate(90 20.25 18)",
    fill: "#CDE9E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 7.875C10.9982 7.875 11.25 8.12684 11.25 8.4375L11.25 21.375L10.125 21.375L10.125 8.4375C10.125 8.12684 10.3768 7.875 10.6875 7.875Z",
    fill: "#CDE9E1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 10.125,
    width: 12.375,
    height: 1.125,
    rx: 0.5625,
    transform: "rotate(145.213 11.25 10.125)",
    fill: "#CDE9E1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 5.62524,
    width: 6.75,
    height: 1.125,
    rx: 0.5625,
    transform: "rotate(145.213 15.75 5.62524)",
    fill: "#CDE9E1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0547,
    y: 13.1273,
    width: 12.375,
    height: 1.125,
    rx: 0.5625,
    transform: "rotate(-144.347 24.0547 13.1273)",
    fill: "#CDE9E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 11.2502C23.3732 11.2502 23.625 11.5021 23.625 11.8127L23.625 16.8752L22.5 16.8752L22.5 11.8127C22.5 11.5021 22.7518 11.2502 23.0625 11.2502Z",
    fill: "#CDE9E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcfHouse);
export default __webpack_public_path__ + "static/media/mcf-house.83105c1c743d9e8a0516c23a100b6d9a.svg";
export { ForwardRef as ReactComponent };